import { searchAccounts } from 'ducks/accountSearchResult';
import { connect } from 'react-redux';
import CustomerSearch from './CustomerSearch';

const mapStateToProps = (state) => ({
  accounts: state.accountSearchResult.accounts,
  ajaxStatus: state.ajax,
  localisation: state.localisation,
  appLoading: state.meta.appLoading,
});

const mapDispatchToProps = {
  searchAccounts: searchAccounts,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerSearch);
